export const COLUMNS = [{
        Header: "Descrição",
        accessor: "descricao",
        campoOrdenacao: "Descricao"
    },
    {
        Header: "Instituição Financeira",
        accessor: "banco",
        campoOrdenacao: "Banco"
    },
    {
        Header: "Produto",
        accessor: "produto",
        campoOrdenacao: "Produto"
    },
    {
        Header: "Convênio",
        accessor: "convenio",
        campoOrdenacao: "Convenio"
    },
    {
        Header: "Vigência",
        accessor: "vigencia",
        campoOrdenacao: "DtInicioVig"
    },
]
